import { CheckboxInput } from '@framework/form/inputs/CheckboxInput.tsx';
import { FormItem } from '@framework/form/item/FormItem.tsx';
import { RuleType } from '../../IRule.ts';
import { CustomValidationRuleMessage } from '../custom/CustomValidationRuleMessage.tsx';

export interface IIntegerRuleComponentProps {}

const fieldName = `rules.${RuleType.Integer}`;

export function IntegerRuleComponent(props: IIntegerRuleComponentProps) {
  return (
    <FormItem name={`${fieldName}.value`} label={null}>
      <CheckboxInput name={`${fieldName}.value`} defaultChecked={false}>
        Solo numeri interi
      </CheckboxInput>
      <CustomValidationRuleMessage
        isGhostType
        name={`${fieldName}.customMessage`}
      />
    </FormItem>
  );
}
